import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import { registerModal, requestToHide, requestToShow } from '.';

const modalMap = {};

const onShowBsModalCb = (event) => {
  const { id } = event.target;
  const { actionFromController } = modalMap[id];

  if (actionFromController === false) {
    requestToShow({ id });

    event.preventDefault();
  }
  modalMap[id].actionFromController = false;
};

const onHiddenBsModalCb = (event) => {
  const { id } = event.target;
  const { actionFromController } = modalMap[id];

  if (actionFromController === false) {
    requestToHide({ id });
  }
  modalMap[id].actionFromController = false;
};

document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('.modal');
  modals.forEach((modalElement) => {
    const { id } = modalElement;
    const btModalInstance = new Modal(modalElement);
    modalMap[id] = {
      modalElement,
      btModalInstance,
      actionFromController: false,
    };
    const onVisibleChange = (value) => {
      modalMap[id].actionFromController = true;
      if (value) {
        btModalInstance.show();
      } else {
        btModalInstance.hide();
      }
    };
    registerModal({ id, onVisibleChange });

    modalElement.addEventListener('show.bs.modal', onShowBsModalCb);
    modalElement.addEventListener('hidden.bs.modal', onHiddenBsModalCb);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const offcanvas = document.querySelectorAll('.offcanvas');
  offcanvas.forEach((offCanvasElement) => {
    const { id } = offCanvasElement;
    const btOffCanvasInstance = new Offcanvas(offCanvasElement);
    modalMap[id] = {
      offCanvasElement,
      btOffCanvasInstance,
      actionFromController: false,
    };
    const onVisibleChange = (value) => {
      modalMap[id].actionFromController = true;
      if (value) {
        btOffCanvasInstance.show();
      } else {
        btOffCanvasInstance.hide();
      }
    };
    registerModal({ id, onVisibleChange });

    offCanvasElement.addEventListener('show.bs.offcanvas', onShowBsModalCb);
    offCanvasElement.addEventListener('hidden.bs.offcanvas', onHiddenBsModalCb);
  });
});
